import { IOrder } from "@modules/Purchasing/services/orders";

export const useOrderDescription = (order: IOrder | undefined) => {
  if (!order) {
    return {
      services: [],
      subscription: [],
      currency: null,
      totalExpenses: 0,
      totalExpensesFees: 0,
      totalServiceFees: 0,
      promoCode: [],
      credit: [],
      advancePayment: [],
    };
  }
  const services = order?.items?.filter((item) => item.itemType === "service");
  const subscription = order?.items.filter(
    (item) => item.itemType === "product"
  );
  const currency = order?.itemsTotalCurrency;

  const totalExpenses =
    services[0]?.expenses.reduce((acc, curr) => {
      return (acc += curr?.amountCents);
    }, 0) ?? 0;

  const totalExpensesFees = services[0]?.expenses?.reduce((total, expense) => {
    const expenseFee = expense.fees?.[0];
    if (expenseFee?.enabled) {
      return total + expenseFee.amountCents;
    }
    return total;
  }, 0);

  const promoCode =
    services[0]?.deductions.filter((item) => item.name === "promo_code") ?? [];
  const credit =
    services[0]?.deductions.filter((item) => item.name === "credit") ?? [];

  const advancePayment =
    services[0]?.deductions.filter((item) => item.name === "pre_payment") ?? [];

  const totalServiceFees = services[0]?.fees?.[0]?.amountCents ?? 0;

  return {
    services,
    subscription,
    currency,
    totalExpenses,
    totalExpensesFees,
    totalServiceFees,
    promoCode,
    credit,
    advancePayment,
  };
};
